<template>
  <a href="#delete" class="btn btn-icon-dark" @click.prevent="confirmDeleteUser">
    <i class="fa fa-trash-o"></i>
  </a>
</template>

<script type="text/javascript">
  import { mapGetters, mapActions } from 'vuex'
  import { getEntitiesForMultiAction } from '@/backend/users'
  import { checkRoleCandidate } from '@/helpers/roles'
  import AtInternetManagingCandidate from '@/helpers/at_internet/managing_candidate'
  import AtInternetManagingManager from '@/helpers/at_internet/managing_manager'

  export default {
    name: 'DeleteUser',
    props: ['user', 'isManager', 'entityId'],
    methods: {
      ...mapActions({
        getDestroyUserPermission: 'users/getDestroyUserPermission',
        deleteUser: 'users/deleteUser'
      }),
      confirmDeleteUser: function(dialog) {
        const payload = {
          userId: this.user.id,
          entityId: this.entityId
        }
        this.getDestroyUserPermission(payload).then((response) => {
          if(response.status == 200 && response.data.can_delete) {

            getEntitiesForMultiAction(this.user.id, 'delete').then(response => {
              let entities = response.data
              entities = entities.map(entity => {
                if (this.entityId == entity.id) {
                  return { ...entity, selected: true }
                }
                return { ...entity, selected: false }
              })
              if (entities.length > 1) {
                this.$store.commit('users/SET_MULTI_ACTION_TYPE', 'delete')
                this.$store.commit('users/SET_ENTITIES_FOR_MULTI_ACTION', entities)
                this.$store.commit('users/SET_WORKING_USER', this.user)
                $('#candidate-multi-action-popup').modal('show')
              } else {
                this.$dialog.confirm(this.deleteMessageConfirmation).then(() => {
                  if(checkRoleCandidate(this.user.role)) {
                    this.user.state === "pending" ? 
                      AtInternetManagingCandidate.sendValidationDeleteCandidatEvent() : 
                      AtInternetManagingCandidate.sendDeleteMemberEvent()
                  } else {
                    AtInternetManagingManager.sendDeleteManagerEvent();
                  }
                  this.deleteUser({
                    user: this.user,
                    entityId: this.entityId,
                    entityIds: [this.entityId]
                  })
                })
              }
            })
          } else {
            this.$dialog.alert(this.$i18n.t('users.messages.user_has_active_offers'))
          }
        })
      },
    },
    computed: {
      ...mapGetters({
        currentUserServices: 'auth/services'
      }),
      userName() {
        return this.user.first_name + ' ' + this.user.last_name
      },
      removableServicesName(){
        var currentUserServiceNames = this.currentUserServices.map(service => service.name);
        var userServiceNames = this.user.services.map(service => service.name);
        var removableServices = [];
        userServiceNames.forEach(function(serviceName) {
          if(currentUserServiceNames.includes(serviceName)){
            removableServices.push(serviceName);
          };
        });
        return removableServices;
      },
      deleteMessageConfirmation() {
        if(this.user.services_count == 1 || this.isManager == true){
          return this.$i18n.t('users.messages.remove_record', {userName: this.userName})
        }
        var removableServices = this.removableServicesName;
        if(removableServices.length == 1){
          return this.$i18n.t('users.messages.remove_service', {userName: this.userName, serviceName: removableServices[0]});
        }else{
          let servicesList = removableServices.map(serviceName => `<li>${serviceName}</li>`)
          return this.$i18n.t('users.messages.remove_services', {userName: this.userName, servicesName: servicesList.join('')});
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/DeleteUser.vue